import React from 'react'
import {BiCopyright} from 'react-icons/bi'
function Footer() {
  return (
    <div>
      <div className=" footer container my-7 border d-flex flex-direction-row justify-content-center">
      <BiCopyright/> <a className='nav-link myname-footer' href="https://iamnejarul.web.app" target="_blank" rel="noopener noreferrer">  Nejarul Islam  </a> <span>| All Rights Reserved</span>
      </div>
    </div>
  )
}

export default Footer
